import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import Button from "@material-ui/core/Button";
import Tabs from "@material-ui/core/Tabs";
import Checkbox from "@material-ui/core/Checkbox";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/theme-monokai";
import axios from "../AxiosClient";
import { useSnackbar } from "notistack";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    display: "flex",
    fontSize: theme.typography.pxToRem(25),
  },
  paper: {
    // backgroundColor: 'transparent',
    borderRadius: theme.spacing(9),
    marginTop: -8,
    marginLeft: -8,
  },
  section: {
    flex: 1,
    margin: theme.spacing(2),
  },
  titleInput: {
    fontSize: 30,
  },
}));
function ApiExample(props) {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState(0);
  const [example, setExample] = useState({
    id: -1,
    description: "",
    uses: [],
    html: "",
    css: "",
    javascript: "",
    title: "",
    menutitle: "",
  });

  useEffect(
    () => {
      if (props.match.params.id) {
        axios
          .get(`/apidocs/${props.match.params.id}`)
          .then((res) => {
            setExample({ ...res.data, uses: res.data.uses.split(",") });
          })
          .catch((err) => {});
      } else {
        setExample({
          id: -1,
          description: "",
          uses: [],
          html: "",
          css: "",
          javascript: "",
          title: "",
          menutitle: "",
        });
      }
    },
    [props.match.params.id]
  );

  const saveExample = () => {
    example.id === -1
      ? axios
          .post("/apidocs/", {
            ...example,
            uses: example.uses.join(),
          })
          .then((res) => {
            enqueueSnackbar("Example saved", { variant: "success" });
            setExample({ ...example, id: res.data.id });
          })
          .catch((err) => {
            enqueueSnackbar("An error occurred saving the example", {
              variant: "error",
            });
          })
      : axios
          .patch(`/apidocs/${example.id}`, {
            ...example,
            uses: example.uses.join(","),
          })
          .then(() => {
            enqueueSnackbar("Example saved", { variant: "success" });
          })
          .catch((err) => {
            enqueueSnackbar("An error occurred saving the example", {
              variant: "error",
            });
          });
  };
  return (
    <>
      <Card>
        <CardHeader
          disableTypography
          title={
            props.currentUser.isOperator === 1 ? (
              <TextField
                fullWidth
                placeholder="Title..."
                value={example.title}
                InputProps={{
                  classes: {
                    input: classes.titleInput,
                  },
                }}
                onChange={(e) => {
                  setExample({ ...example, title: e.target.value });
                }}
              />
            ) : (
              <Typography variant="h4">{example.title}</Typography>
            )
          }
        />
        <CardContent
          style={{
            height: "88%",
            display: "flex",
            flexFlow: "column",
            paddingTop: 0,
          }}
        >
          <div>
            {props.currentUser.isOperator === 1 ? (
              <>
                <TextField
                  placeholder="Description..."
                  fullWidth
                  multiline
                  value={example.description}
                  onChange={(e) => {
                    setExample({ ...example, description: e.target.value });
                  }}
                />
              </>
            ) : (
              <>{example.description}</>
            )}
          </div>
          <div style={{ marginTop: 10 }}>
            {props.currentUser.isOperator === 1 ? (
              <div style={{ display: "flex" }}>
                <Autocomplete
                  style={{ flex: 3, marginRight: 20 }}
                  classes={{
                    tag: classes.chip,
                    input: classes.input,
                  }}
                  multiple
                  disableCloseOnSelect
                  handleHomeEndKeys
                  openOnFocus
                  options={[
                    "uks",
                    "authservice",
                    "taxonomyservice",
                    "discussionservice",
                    "attachmentservice",
                    "reportservice",
                  ]}
                  value={example.uses}
                  onChange={(_e, val) => {
                    setExample({ ...example, uses: val });
                  }}
                  renderOption={(option, { selected }) => (
                    <React.Fragment>
                      <Checkbox
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option}
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label={"Services used"}
                    />
                  )}
                />
                <TextField
                  variant="standard"
                  label={"Menu group"}
                  value={example.menutitle}
                  onChange={(e) => {
                    setExample({ ...example, menutitle: e.target.value });
                  }}
                  style={{ flex: 1 }}
                />
              </div>
            ) : (
              <>
                Services used:{" "}
                {example.uses.map((cat, idx) => {
                  return <Chip key={idx} label={cat} />;
                })}
              </>
            )}
          </div>
          <div className={classes.section}>
            <Grid container>
              <Grid item style={{ flex: 1 }}>
                <Tabs
                  value={activeTab}
                  onChange={(_e, value) => setActiveTab(value)}
                  className={classes.tabs}
                >
                  <Tab label={"JavaScript"} id="js-tab" />
                  <Tab label={"HTML"} id="html-tab" />
                  <Tab label={"CSS"} id="css-tab" />
                </Tabs>
                {activeTab === 0 && (
                  <div className={classes.section}>
                    <AceEditor
                      mode="javascript"
                      theme="monokai"
                      onChange={(newValue) =>
                        setExample({ ...example, javascript: newValue })
                      }
                      name="javascript"
                      setOptions={{ useWorker: false }}
                      editorProps={{ $blockScrolling: true }}
                      value={example.javascript}
                      width={"100%"}
                      fontSize={14}
                    />
                  </div>
                )}
                {activeTab === 1 && (
                  <div className={classes.section}>
                    <AceEditor
                      mode="html"
                      theme="monokai"
                      onChange={(newValue) =>
                        setExample({ ...example, html: newValue })
                      }
                      name="html"
                      setOptions={{ useWorker: false }}
                      editorProps={{ $blockScrolling: true }}
                      value={example.html}
                      width={"100%"}
                      fontSize={14}
                    />
                  </div>
                )}
                {activeTab === 2 && (
                  <div className={classes.section}>
                    <AceEditor
                      mode="css"
                      theme="monokai"
                      onChange={(newValue) =>
                        setExample({ ...example, css: newValue })
                      }
                      name="css"
                      setOptions={{ useWorker: false }}
                      editorProps={{ $blockScrolling: true }}
                      value={example.css}
                      width={"100%"}
                      fontSize={14}
                    />
                  </div>
                )}
              </Grid>
              <Grid item style={{ flex: 0.75 }}>
                <div className={classes.section}>
                  <h2>Live Example</h2>
                </div>
                <iframe
                  // sandbox
                  srcDoc={
                    "<html>" +
                    "<head>" +
                    "<style>" +
                    example.css +
                    "</style>" +
                    "<script type=\"module\">" + 
                    example.javascript
                      .replaceAll("API_LOCATION", props.apiLocation) +
                      // .replaceAll(
                      //   "ACCESS_TOKEN",
                      //   localStorage.getItem("access_token")
                      // ) +
                    "</script>" +
                    "</head>" +
                    "<body>" +
                    example.html
                      .replaceAll("API_LOCATION", props.apiLocation) +
                      // .replaceAll(
                      //   "ACCESS_TOKEN",
                      //   localStorage.getItem("access_token")
                      // ) +
                    "</body>" +
                    "</html>"
                  }
                  style={{ border: 0, height: "500px", width: "100%" }}
                />
              </Grid>
            </Grid>
          </div>

          {props.currentUser.isOperator === 1 && (
            <CardActions>
              <Button onClick={saveExample}>Save</Button>
            </CardActions>
          )}
        </CardContent>
      </Card>
    </>
  );
}
const mapStateToProps = (state) => ({
  apiLocation: state.setting.apiLocation,
  currentUser: state.user.currentUser,
});
export default connect(mapStateToProps)(withTranslation()(ApiExample));
